import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { useEffect, useState } from "react";
// eslint-disable-next-line import/no-cycle
import YunoCardCvCElement from "../YunoCardCvCElement/YunoCardCvCElement.web";
import YunoCardExpiryElement from "../YunoCardExpiryElement/YunoCardExpiryElement.web";
import YunoCardNumberElement from "../YunoCardNumberElement/YunoCardNumberElement.web";

function YunoCardElement({
  onValidFields,
  onInvalidFields,
}: {
  /**
   * Fires when the fields used internally by this component is deemed valid
   */
  onValidFields?: () => void;
  /**
   * Function called when the fields used internally by this component is deemed invalid
   */
  onInvalidFields?: () => void;
}) {
  const [validFields, setValidFields] = useState({
    number: false,
    expiry: false,
    cvc: false,
  });

  useEffect(() => {
    if (validFields.number && validFields.expiry && validFields.cvc) {
      onValidFields?.();
    } else {
      onInvalidFields?.();
    }
  }, [validFields, onValidFields, onInvalidFields]);

  return (
    <Box
      style={{
        background: "transparent",
      }}
    >
      <Box mt="xs" mb="xs">
        <YunoCardNumberElement
          onValidField={() => {
            setValidFields((prev) => ({ ...prev, number: true }));
          }}
          onInvalidField={() => {
            setValidFields((prev) => ({
              ...prev,
              number: false,
            }));
          }}
        />
      </Box>
      <Flex mt="xs" mb="xs" gap="xs">
        <Box
          style={{
            flex: 1,
          }}
        >
          <YunoCardExpiryElement
            onValidField={() => {
              setValidFields((prev) => ({ ...prev, expiry: true }));
            }}
            onInvalidField={() => {
              setValidFields((prev) => ({
                ...prev,
                expiry: false,
              }));
            }}
          />
        </Box>
        <Box
          style={{
            flex: 1,
          }}
        >
          <YunoCardCvCElement
            onValidField={() => {
              setValidFields((prev) => ({ ...prev, cvc: true }));
            }}
            onInvalidField={() => {
              setValidFields((prev) => ({
                ...prev,
                cvc: false,
              }));
            }}
          />
        </Box>
      </Flex>
    </Box>
  );
}

export default YunoCardElement;
